import React, { useState } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';

import { ReactComponent as CircleUnchecked } from '../../../../assets/img/check.svg';
import { ReactComponent as CircleChecked } from '../../../../assets/img/checkFilled.svg';
import FloatingButton from '../../../../components/FloatingButton';
import { NumberFormatCustom } from '../../../../components/NumberFormartCustom/NumberFormatCustom.component';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import useForm from '../../../../helpers/useForm';
import DataValidators from './DataValidation.validations';

const DataValidation = () => {
  const { updateSinisterBody, sinister_body, nextStep } =
    useSinisterDataContext();
  const { user } = useAuthDataContext();

  const [policy_owner_was_driving, setPolicy_owner_was_driving] = useState(
    sinister_body.policy_owner_was_driving || true
  );
  const [defaultValues] = useState({
    email: sinister_body?.driverData?.email || '',
    phone_number: sinister_body?.driverData?.phone_number || '',
    identification_number:
      sinister_body?.driverData?.identification_number || '',
    full_name: sinister_body?.driverData?.full_name || '',
  });

  const callNextStep = () => {
    updateSinisterBody({ driverData: values });
    updateSinisterBody({ policy_owner_was_driving });
    dataLayerPush('siniestro_conductor', user?.id, {
      fieldName: 'opcion_siniestro_conductor',
      fieldValue: policy_owner_was_driving
        ? 'Titular de la póliza'
        : 'Otra persona',
    });
    nextStep();
  };

  const { values, errors, handleChange } = useForm(
    callNextStep,
    !policy_owner_was_driving ? DataValidators : {},
    defaultValues
  );

  return (
    <form>
      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography
              variant="h3"
              style={{ fontFamily: 'Inter', color: '#000' }}
            >
              ¿Quién conducía?
            </Typography>
          </Box>
        </Grid>
        <Grid item lg={12}>
          <Box mr={2} my={2}>
            <FormControl component="fieldset">
              <RadioGroup aria-label="position">
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CircleUnchecked />}
                      checkedIcon={<CircleChecked />}
                      checked={policy_owner_was_driving}
                      color="secondary"
                      onChange={(event) =>
                        setPolicy_owner_was_driving(event.target.checked)
                      }
                    />
                  }
                  label="Titular de la póliza"
                  name="driver"
                  id="driver"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CircleUnchecked />}
                      checkedIcon={<CircleChecked />}
                      checked={!policy_owner_was_driving}
                      color="secondary"
                      onChange={(event) =>
                        setPolicy_owner_was_driving(!event.target.checked)
                      }
                    />
                  }
                  label="Otra persona"
                  name="other_driver"
                  id="other_driver"
                  onChange={handleChange}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        {!policy_owner_was_driving && (
          <Grid container>
            <Grid item xs={12} md={6}>
              <Box mr={2} my={2}>
                <Typography variant="subtitle2">Nombre y Apellido </Typography>
                <TextField
                  value={values.full_name}
                  size="small"
                  error={!!errors['full_name']}
                  helperText={errors['full_name']}
                  onChange={handleChange}
                  fullWidth={true}
                  name="full_name"
                  id="full_name"
                  placeholder="Ingresá tu Nombre y Apellido"
                  variant="outlined"
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box mr={2} my={2}>
                <Typography variant="subtitle2">Nº de documento *</Typography>
                <TextField
                  InputProps={{
                    inputComponent: NumberFormatCustom as any,
                  }}
                  value={values.identification_number}
                  size="small"
                  error={Boolean(errors['identification_number'])}
                  helperText={errors['identification_number']}
                  onChange={handleChange}
                  fullWidth={true}
                  name="identification_number"
                  id="identification_number"
                  placeholder="Ingresá tu número de documento"
                  variant="outlined"
                />
              </Box>
            </Grid>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Box mr={2} my={2}>
                  <Typography variant="subtitle2">Email *</Typography>
                  <TextField
                    // defaultValue={sinister_body?.driverData?.email || user.email}
                    type="email"
                    size="small"
                    onChange={handleChange}
                    fullWidth={true}
                    error={Boolean(errors['email'])}
                    helperText={errors['email']}
                    name="email"
                    id="email"
                    placeholder="Ingresá tu email"
                    variant="outlined"
                    value={values.email}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box mr={2} my={2}>
                  <Typography variant="subtitle2">Teléfono *</Typography>
                  <TextField
                    InputProps={{
                      inputComponent: NumberFormatCustom as any,
                    }}
                    size="small"
                    onChange={handleChange}
                    fullWidth={true}
                    error={Boolean(errors['phone_number'])}
                    helperText={errors['phone_number']}
                    name="phone_number"
                    id="phone_number"
                    placeholder="Teléfono *"
                    variant="outlined"
                    value={values.phone_number}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid container justify="center">
          <Grid item xs={12} sm={6}>
            <Box my={4}>
              <FloatingButton
                disabled={
                  policy_owner_was_driving
                    ? false
                    : !!Object.keys(errors).length ||
                      !values.email ||
                      !values.phone_number ||
                      !values.full_name ||
                      !values.identification_number
                }
                onClick={callNextStep}
              >
                Continuar
              </FloatingButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default DataValidation;
